module.exports = __webpack_public_path__ + "img/laboratorio_9-16_810.f25ab62a.jpg";